/*
 * Copyright © 2025 Himitsu Lab Limited. All Rights Reserved.
 */

import { CommonEntity } from './commonEntity.model';
import { Meeting } from './meeting.model';

export enum RecordingRequestStatus {
    Open = "Open",
    Shared = "Shared",
    Denied = "Denied"
  }

export interface RecordingRequest extends CommonEntity {
    meeting: Meeting;
    RecordingRequestStatus: RecordingRequestStatus;
}